import styled from "styled-components";
import css from "@styled-system/css";

import Button from "../Button/Button";
import Icon from "../Icon/Icon";
import { PaginationItemType, UsePaginationItem } from "./pagination.type";

interface PaginationItemsProps extends UsePaginationItem {
  type: PaginationItemType;
  page: number | JSX.Element;
}

const NavButton = styled(Button)`
  height: 40px;
  min-width: 40px;
  &:disabled {
    box-shadow: none;
  }
  ${css({
    fontSize: "body-small",
  })}
`;

const PaginationItem = (props: PaginationItemsProps) => {
  const { type, page, selected, ...other } = props;
  if (type === "start-ellipsis" || type === "end-ellipsis") {
    return (
      <NavButton variant="button" px={0} mr={3} {...other}>
        ...
      </NavButton>
    );
  }
  if (type === "prev" || type === "next") {
    return (
      <NavButton
        variant="button"
        {...other}
        px={3}
        my={1}
        mr={3}
        css={`
          text-transform: capitalize;
        `}
      >
        {type === "prev" && (
          <Icon
            name="chevron-left"
            height={14}
            width={14}
            weight="solid"
            mr={2}
          ></Icon>
        )}
        {type}
        {type === "next" && (
          <Icon
            name="chevron-right"
            height={14}
            width={14}
            weight="solid"
            ml={2}
          ></Icon>
        )}
      </NavButton>
    );
  }
  if (type === "first" || type === "last") {
    return (
      <NavButton
        variant="button"
        {...other}
        px={2}
        my={1}
        mr={3}
        css={`
          text-transform: capitalize;
        `}
      >
        {type === "first" && (
          <Icon
            name="chevron-double-left"
            height={14}
            width={14}
            weight="solid"
          ></Icon>
        )}
        {type === "last" && (
          <Icon
            name="chevron-double-right"
            height={14}
            width={14}
            weight="solid"
          ></Icon>
        )}
      </NavButton>
    );
  }
  return (
    <NavButton
      variant="button"
      {...other}
      p={0}
      my={1}
      mr={3}
      className={selected ? "active" : undefined}
    >
      {type === "page" && page}
    </NavButton>
  );
};

export default PaginationItem;
